module.exports = __webpack_public_path__ + "img/ic_search_black_48px.696ffb7d.svg";